export const StoreKey = Symbol('Store');
export const AxiosKey = Symbol('Axios');
